import React from "react";
import ReactDOM from "react-dom/client";
// import axios from "axios";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { store, persistedStore } from "./redux/store/store";
// import { logout } from "./redux/reduxSlice/authSlice";
import App from "./App";
import "./index.scss";
// import { notification } from "antd";

// axios.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Response Interceptor
// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Check for specific error status codes from the server response.
//     const status = error.response && error.response.status;

//     if (status === 401 || status === 403) {
//       const message =
//         status === 401
//           ? "Your session has expired. Please log in again."
//           : "You don't have permission to access this resource. Please log in again.";

//       // Show a user-friendly message using Ant Design notification.
//       notification.error({
//         message: "Authorization Error",
//         description: message,
//         placement: "topRight",
//       });

//       console.warn(
//         `${status === 401 ? "Unauthorized" : "Forbidden"
//         } access. Logging out...`
//       );

//       // Dispatch the logout action to clear user state and local storage.
//       store.dispatch(logout());

//       // Redirect to the login page.
//       // A check is added to prevent a reload loop if already on the login page.
//       if (window.location.pathname !== "/login") {
//         window.location.href = "/login";
//       }
//     }

//     return Promise.reject(error);
//   }
// );

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// live mode
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistedStore}>
      <GoogleOAuthProvider clientId={clientId}>
        <Elements stripe={stripePromise}>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </Elements>
      </GoogleOAuthProvider>
    </PersistGate>
  </Provider>
);

reportWebVitals();